import React from 'react';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const AwardsContent = () => {

  return (
    <section className="sidebar-page-container p_relative">
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12 content-side">
                        <div className="blog-standard-content">
                        <div className="news-block-one wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                                <div className="inner-box">
                                    {/* <figure className="col-lg-6 image-box spurthi-img-awards"><img src="assets/images/team/team-17.jpeg" alt="" /></figure> */}
                                    <div className="col-lg-12 lower-content">
                                        <div className="row clearfix">
                                            {/* <div className="orange-circle"></div>
                                            <figure className="col-lg-6 col-md-6 col-sm-12 image-column "><img src="assets/images/team/team-15.png" alt="" /></figure> */}
                                            <div className="col-lg-12 inner">
                                                <div className="category"><a href="#">Surgeon</a></div>
                                                <h3><a href="#">Dr.K.Spurthi Reddy</a></h3>
                                                <ul className="post-info clearfix">
                                                    {/* <li><i className="icon-34"></i>10 Oct, 2021</li> */}
                                                    <li><i className="icon-35"></i><a href="#">DO;DNB;FICO;FPOS</a></li>
                                                </ul>
                                                <p>
                                                    <ul className="list-style-one clearfix">
                                                        <li>University Gold medal in ENT (2007).</li>
                                                        <li>University Gold medal in Dip.Ophthalmology (2014-Combined AP and Telangana).</li>
                                                        <li>Post graduation at premier institute, Aravind Eye Hospital, Pondicherry.</li>
                                                        <li>Best Physical poster award (Uvea-AIOC 2017, Jaipur).</li>
                                                        <li>Finalist of Allergan Erudio quiz among three countries (Jan 2017-Delhi).</li>
                                                        <li>Multiple presentations at regional, state, and national levels.</li>
                                                    </ul>
                                                </p>
                                                <div className="link"><a href="/DoctorProfile">Read more</a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
  }
  
  export default AwardsContent;